import request from "@/utils/request";

let domain = '';
let accountUrl = '';
if(window.location.host.includes('-p')){
	domain = 'https://p.landui.com/';
	accountUrl = 'https://account-p.console.landui.com/';
}else if(window.location.host.includes('st')){
	domain = 'https://www.st.landui.cn/';
	accountUrl = 'https://account.st.landui.cn/';
}else{
	domain = 'https://www.landui.com/';
	accountUrl = 'https://account.console.landui.com/';
}

export function webMsg() {
	return request({
		url: domain + 'user/index/webMsg',
		method: 'GET'
	})
}

export function isLogin() {
  return request({
    url: accountUrl+'api/users/user/data',
    method: 'get'
  })
}

export function captchaFetch() {
  return request({
    url: accountUrl+'api/common/captcha',
    method: 'get'
  })
}
export function loginSendCode(param) {
  return request({
    url: accountUrl+'api/users/login/sendsmscode',
    method: 'post',
    data: param,
	headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
export function getuserhasproduct(param) {
  return request({
    url: accountUrl+'api/users/getuserhasproduct',
    method: 'post',
	data: param,
	headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
export function wechatlogin() {
  return request({
    url: accountUrl+'api/users/wechat/oauth',
    method: 'get'
  })
}

export function qqlogin() {
  return request({
    url: accountUrl+'api/users/qq/oauth',
    method: 'get'
  })
}

export function accountcheck(param) {
  return request({
    url: accountUrl+'api/users/login/accountcheck',
    method: 'post',
    data: param,
	headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
export function loginAccount(param) {
  return request({
    url: accountUrl+'api/users/login/account',
    method: 'post',
    data: param,
	headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
export function loginMobile(param) {
  return request({
    url: accountUrl+'api/users/login/mobile',
    method: 'post',
    data: param,
	headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export function apiGetUserInfo() {
    return request({
        url: 'user/center/api/get/user/data',
        method: 'post'
    })
}

export function setActivate() {
    return request({
        url: 'user/center/api/ld/user/activate',
        method: 'post'
    })
}

export function getVersion() {
    return request({
        url: 'user/center/api/instance/get/version',
        method: 'post'
    })
}
export function getSpec() {
  return request({
    url: 'user/center/api/specifications/query/all',
    method: 'post'
  })
}

export function duration() {
  return request({
    url: 'user/center/api/query/duration/config',
    method: 'post'
  })
}

export function priceCalculation(param) {
  return request({
    url: 'user/center/api/get/instance/create/price',
    method: 'post',
    data: param
  })
}

export function pay(param) {
  return request({
    url: 'user/center/api/instance/create',
    method: 'post',
    data: param
  })
}

export function captchaGet() {
  return request({
    url: 'user/center/api/instance/common/captcha',
    method: 'get'
  })
}

export function smsCodeGet(param) {
  return request({
    url: 'user/center/api/instance/common/smscode',
    method: 'post',
    data: param
  })
}
